import { http } from '@/providers/apis/http';
import { competencySerializer } from '@/providers/serializers/competency/competency';
import { DomainModel } from '@/models/proficiency/domain';
import { FacetMatrix } from '@/models/proficiency/facet-matrix';

export class CompetencyAPI {

  private static INSTANCE = new CompetencyAPI();

  private namespace = 'api/ds/users';

  private missionControlNamespace = 'api/missioncontrol/v1';

  private missionControlNamespaceV2 = 'api/missioncontrol/v2';

  private rgNamespace = 'api/routegenerator/v2/routes';

  static get instance() {
    return this.INSTANCE;
  }

  public fetchUserDomainCompetencyMatrix(params: any): Promise<DomainModel[]> {
    const endpoint = `${this.namespace}/v2/tx/competency/matrix/domain`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return competencySerializer.serializeDomainCompetencyMatrix(response.data);
    });
  }

  public getCompetencyMatrixCoordinates(params: any) {
    const endpoint = `${this.namespace}/v2/tx/competency/matrix/coordinates`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return competencySerializer.serializeMatrixCoOrdinates(response.data);
    });
  }

  public fetchAllFacetsCompetencyMatrix<T>(params: any): Promise<FacetMatrix[]> {
    const endpoint = `${this.namespace}/v2/tx/subjects/competency/matrix`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return competencySerializer.serializeFacetsCompetencyMatrix(response.data);
    });
  }


  public fetchDomainTopicCompetencyMatrix(params: any) {
    const endpoint = `${this.missionControlNamespace}/tx/competency/matrix/domain/topics`;
    // const endpoint = `${window.location.origin}/stubs/dtc.json`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return competencySerializer.serializeDomainTopicMatrix(response.data);
    });
  }

  public fetchSubjectDomainTopicMetadata(params: any) {
    const endpoint = `${this.missionControlNamespaceV2}/tx/subject/domain/topics`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return competencySerializer.serializeDomainTopicMetadata(response.data);
    });
  }

  public generateRoute(params: any) {
    const endpoint = `${this.rgNamespace}/subject/${params.subjectId}/topic/${params.topicCode}/user/${params.userId}/fetch`;
    const headers = http.getTokenHeaders();
    const queryParams = params.queryParams;
    return http.get(endpoint, headers, queryParams).then((response) => {
      return competencySerializer.normalizeRoutes(response.data);
    });
  }
}

export const competencyAPI = CompetencyAPI.instance;
